<template>
  <div id="search_container">
    <HorairesCourseInfos
      v-if="!is_live"
      :courses="horaire_courses"
      @updateHoraires="updateCourseHoraires"
    ></HorairesCourseInfos>
    <div class="search_form">
      <b-form-file
        class="file_input"
        accept="image/*"
        multiple
        placeholder="Importer des photos à la galerie de l'évenement..."
        drop-placeholder="Glisser des photos ici..."
        @change="selectPhotos"
      ></b-form-file>
    </div>
    <div class="sep"></div>
    <b-button @click="uploadPhotos()" v-if="!upload_started">
      <b-icon icon="cloud-upload"></b-icon> Envoyer les photos
    </b-button>
    <h2 style="color: white" v-if="upload_ended">Envoi terminé</h2>
    <div class="sep"></div>
    <SpinnerLoadingUpload
      v-if="upload_started && !upload_ended"
    ></SpinnerLoadingUpload>
    <ProgressInfosUpload
      v-if="upload_started"
      :progress="progressInfos"
      :photos_treated="photos_treated"
      :key="photos_treated"
    ></ProgressInfosUpload>
  </div>
</template>

<script>
import axios from "axios";
import SpinnerLoadingUpload from "@/components/SpinnerLoadingUpload.vue";
import ProgressInfosUpload from "@/components/ProgressInfosUpload.vue";
import HorairesCourseInfos from "@/components/HorairesCourseInfos.vue";
export default {
  components: {
    SpinnerLoadingUpload,
    ProgressInfosUpload,
    HorairesCourseInfos,
  },
  data() {
    return {
      is_live: true,
      horaire_courses: [],
      upload_started: false,
      upload_ended: false,
      photos_pending_upload: [],
      progressInfos: [],
      photos_treated: 0,
    };
  },
  methods: {
    selectPhotos(event) {
      this.progressInfos = [];
      this.photos_pending_upload = event.target.files;
      for (let i = 0; i < this.photos_pending_upload.length; i++) {
        this.progressInfos[i] = {
          percentage: 0,
          message: "",
          filename: this.photos_pending_upload[i].name,
        };
      }
    },

    async uploadPhotos() {
      this.upload_started = true;
      this.photos_treated = 0;
      for (let i = 0; i < this.photos_pending_upload.length; i++) {
        var data = new FormData();
        data.append("base", this.$route.params.base);
        data.append(
          "image",
          this.photos_pending_upload[i],
          this.photos_pending_upload[i].name
        );
        const response = await axios
          .post(this.$store.state.base_url + "/list_photos/post.php", data)
          .then(function (response) {
            return response.data;
          });
        if (response.message === "") {
          this.progressInfos[i].percentage = 100;
        }
        this.progressInfos[i].message = response.message;
        this.photos_treated++;
      }
      this.upload_ended = true;
    },
    updateCourseHoraires(h) {
      var data = {"id_module" : this.$store.state.module.id,"horaires" : h};

      axios
        .post(this.$store.state.base_url + "/course_infos/update.php", data)
        .then(function (response) {
          console.log(response.data);
        });
    },
  },
  mounted() {
    var _this = this;
    axios
      .get(
        this.$store.state.base_url +
          "/course_infos/get.php?id=" +
          this.$store.state.module.id
      )
      .then(function (response) {
        _this.is_live = response.data.is_live;
        _this.horaire_courses = response.data.horaire_courses;
        console.log(response.data);
      });
  },
};
</script>

<style lang="scss" scoped>
</style>